export const authStoreName = "artBox";
export const moimClientIdStoreName = "moim-client";
export const ZIGGLE_GROUP_ID = "G0Y2OK5475"; // NOTE: ziggle ziggle id
